import palette from '../palette';
import typography from '../typography';

export default {
  styleOverrides: {
    root: {}
  }
};
